export default __webpack_public_path__ + "static/media/p2.089104f0.PNG";